import vizzleAxios from './service';
import { getUserToken } from '../utils/VizzleSessionStorage';
import { SPEECH_TOKEN_URL, createSpeechTokenRequestHeaders, getLessonGuestToken } from '../utils/LessonGuestToken';

let lastGetTokenTime = null;
let tokenCache = null;

export const getSpeechToken = async () => {
  const endTime = new Date();

  if (tokenCache && lastGetTokenTime) {
    const difference = endTime.getTime() - lastGetTokenTime.getTime(); // This will give difference in milliseconds
    const resultInMinutes = Math.round(difference / 60000);
    if (resultInMinutes < 10) {
      return tokenCache;
    }
  }
  const result = await vizzleAxios.get(SPEECH_TOKEN_URL, {
    headers: createSpeechTokenRequestHeaders(getUserToken(), getLessonGuestToken()),
  });
  tokenCache = result.data;
  lastGetTokenTime = new Date();
  return tokenCache;
};
